import { KC_Sizes } from "../ds_commons";

const SM_SIZE = 8;
const M_SIZE = 24;
const REG_SIZE = 32;
const L_SIZE = 48;
const XL_SIZE = 72;

export const separatorSizesMap = new Map();
separatorSizesMap.set(KC_Sizes.sm, SM_SIZE);
separatorSizesMap.set(KC_Sizes.m, M_SIZE);
separatorSizesMap.set(KC_Sizes.reg, REG_SIZE);

separatorSizesMap.set(KC_Sizes.l, L_SIZE);
separatorSizesMap.set(KC_Sizes.xl, XL_SIZE);
separatorSizesMap.set(KC_Sizes.default, M_SIZE);
